import * as R from 'ramda'
import { combineEpics, Epic } from 'redux-observable'
import { of } from 'rxjs'
import {
  catchError,
  filter,
  map,
  mergeMap,
  withLatestFrom,
} from 'rxjs/operators'
import {
  IOrgenhetActions,
  orgenhetActions,
  orgenhetActionsTypes,
} from '../store'
import { ICommonApi } from '../../../../../api'
import { IStoreState } from '../../../../../reducers/types'
import { ENDPOINT } from '../../../../../constants'
import { commonRedux } from '../../../../../common/redux'

const { isOfType } = commonRedux

export const fetchOrgenhetFromRemoteEpic =
  (
    commonApi: ICommonApi
  ): Epic<IOrgenhetActions, IOrgenhetActions, IStoreState> =>
  (action$, state$) =>
    action$.pipe(
      filter(isOfType(orgenhetActionsTypes.FETCH_ID)),
      withLatestFrom(state$),
      mergeMap(([{ id }, state]) =>
        of(id).pipe(
          commonApi.get(`${ENDPOINT.ORGENHET}/orgenheter/id/${id}`, state),
          map((data) => orgenhetActions.fetchIdOk(R.omit(['children'], data))),
          catchError((err) => of(orgenhetActions.fetchIdFail(id, err.message)))
        )
      )
    )

export default (commonApi: ICommonApi) =>
  combineEpics(fetchOrgenhetFromRemoteEpic(commonApi))
